import { TypeKeys, WidgetBlockAction } from './types';

interface ReportLocation {
    active: boolean;
    coordinates: [number, number];
    id: string;
    name: string;
    tags: string[];
}

type SetReportAction = WidgetBlockAction<TypeKeys.SET_REPORT_LOCATION, { reportLocation: ReportLocation }>;

const setReportLocation = (widgetId: string, instanceId: string, reportLocation: ReportLocation): SetReportAction => ({
    type: TypeKeys.SET_REPORT_LOCATION,
    payload: {
        widgetId,
        instanceId,
        reportLocation,
    },
});

export default setReportLocation;
export { ReportLocation, SetReportAction };
